var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearCsv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38293 0 0 5.38293 0 12C0 18.6171 5.38293 24 12 24C18.6171 24 24 18.6171 24 12C24 5.38293 18.6171 0 12 0Z",
    fill: "#101821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.419 15.0043C16.8099 15.3954 16.8099 16.0273 16.419 16.4184C16.224 16.6135 15.968 16.7114 15.7118 16.7114C15.4558 16.7114 15.1998 16.6135 15.0048 16.4184L11.9999 13.4133L8.99495 16.4184C8.79994 16.6135 8.54396 16.7114 8.28798 16.7114C8.03181 16.7114 7.77583 16.6135 7.58083 16.4184C7.1899 16.0273 7.1899 15.3954 7.58083 15.0043L10.586 11.9994L7.58083 8.99443C7.1899 8.60332 7.1899 7.97142 7.58083 7.58031C7.97194 7.18938 8.60384 7.18938 8.99495 7.58031L11.9999 10.5854L15.0048 7.58031C15.3959 7.18938 16.0278 7.18938 16.419 7.58031C16.8099 7.97142 16.8099 8.60332 16.419 8.99443L13.4138 11.9994L16.419 15.0043Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCsv);
export default __webpack_public_path__ + "static/media/clear-csv.1efd1748.svg";
export { ForwardRef as ReactComponent };